export const DISCOUNT_EARLY_BIRD = 'EARLY_BIRD';
export const DISCOUNT_LAST_MINUTE = 'LAST_MINUTE';
